import React from 'react';
import BeachMenuSection from '@/components/BeachMenuSection';

const BeachMenuPage = () => {
  return (
    <div className="min-h-screen" style={{ background: '#0A0015' }}>
      <BeachMenuSection />
    </div>
  );
};

export default BeachMenuPage;
